"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiftsPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../../constants/routes");
var console_1 = require("../../../../../reducers/slices/console");
var gift_categories_table_1 = require("./gift_categories_table");
var gift_category_1 = __importDefault(require("./gift_category"));
var GiftsPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)(); //<AppDispatch>
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Gift Categories"));
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/*", element: (0, jsx_runtime_1.jsx)(gift_categories_table_1.GiftCategoriesTablePage, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "".concat(routes_1.GIFT_CATEGORY_DETAILS_ROUTE, "/:giftCategoryId?"), element: (0, jsx_runtime_1.jsx)(gift_category_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "".concat(routes_1.GIFT_CATEGORY_ROUTE, "?"), element: (0, jsx_runtime_1.jsx)(gift_categories_table_1.GiftCategoriesTablePage, {}) })] }) }));
};
exports.GiftsPage = GiftsPage;
